import styles from './style.module.css';

import { useEffect, useId, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Clipboard } from '../Clipboard';
import { ShareButton } from '../ShareButtons';
import { ICardReveal, ISlideOptions } from './interfaces';

import moment from 'moment';
import * as routes from '../../constants/Routes';
import { getYouTubeEmbed } from '../../utils/getYouTubeEmbed';
import { Button } from '../Button';

function CardReveal({
  title,
  frame,
  image,
  action,
  idProps,
  ctaText,
  client,
  player,
  isInteract,
  actionImagesBase64,
}: ICardReveal) {
  const navigate = useNavigate();
  const [isOpenReveal, setIsOpenReveal] = useState<boolean>();
  const [dataSlideVideo, setDataSlideVideo] = useState<Array<object>>();
  const [dataSlideImages, setDataSlideImages] = useState<Array<object>>();

  const [cartazCover, setCartazCover] = useState<any>();

  const id = useId();

  useEffect(() => {
    const dataContentActionVideo: Array<object> = [];
    const dataContentActionImages: Array<object> = [];

    if (action.images && action.images.length >= 1 && action.videoURL !== '') {
      dataContentActionVideo.push({
        urlVideo: getYouTubeEmbed(action.videoURL),
      });

      dataContentActionImages.push({
        urlImages: action.images,
      });

      setDataSlideVideo(dataContentActionVideo);
      setDataSlideImages(dataContentActionImages);
    }
  }, []);

  useEffect(() => {
    generateBase64();
  }, [actionImagesBase64]);

  const imageUrlToBase64 = async (url: any): Promise<any> => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((onSuccess, onError) => {
      try {
        const reader = new FileReader();
        reader.onload = function () {
          onSuccess(this.result);
        };
        reader.readAsDataURL(blob);
      } catch (e) {
        onError(e);
      }
    });
  };

  const generateBase64 = async () => {
    if (action && action.images) {
      let imageUrl = '';
      let imgBase64 = '';
      const logoImgBase64 = await imageUrlToBase64(client.logoURL);
      const qrCodeBase64 = await imageUrlToBase64(
        `https://api.qrserver.com/v1/create-qr-code/?data=${action.shareUrl}`
      );

      if (action.defaultImagePoster && action.defaultImagePoster !== 'false') {
        imageUrl = action.defaultImagePoster;
        imgBase64 = await imageUrlToBase64(imageUrl);
      } else {
        imageUrl = action.images[0]?.url;
        imgBase64 = await imageUrlToBase64(action.images[0]?.url);
      }

      setCartazCover({
        imageUrl,
        imgBase64,
        logoImgBase64,
        qrCodeBase64,
      });
    }
  };

  function getUniqueId() {
    return id.replace(/:/g, '');
  }

  function renderImageCardBanner(image: any) {
    return <img src={image} alt="imagem" />;
  }

  function renderFrameCardBanner(frame: any) {
    return (
      <div className="ratio ratio-16x9">
        <iframe
          src={getYouTubeEmbed(frame)}
          allow="accelerometer; autoplay; loop; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    );
  }

  const onHandleActionDetails = (action: any) => {
    if (action?.actionType === 'informational') {
      window.open(action.pageURL, '_blank');
    } else {
      navigate(`${routes.ACTION_DETAILS}/${action.id}`);
    }
  };

  function handleShareReveal() {
    setIsOpenReveal(!isOpenReveal);
  }

  return (
    <div
      className="col-12 col-sm-12 col-md-6 col-lg-4"
      key={idProps}
      id={idProps}
    >
      <div className={styles.cardReveal}>
        <div className={styles.cardBanner}>
          {frame && getYouTubeEmbed(frame) && renderFrameCardBanner(frame)}
          {image && renderImageCardBanner(image)}
          {dataSlideVideo && dataSlideImages && (
            <>
              <div
                id={getUniqueId()}
                key={idProps}
                className="carousel slide "
                data-bs-ride="carousel"
              >
                <div className="carousel-inner" id="cards-slide-wide">
                  {dataSlideImages.map((item: ISlideOptions) => {
                    return (
                      item.urlImages &&
                      item.urlImages.map((image, index) => {
                        return (
                          <div className={`carousel-item active`} key={index}>
                            <img
                              src={image.url}
                              className="d-block w-100"
                              alt={''}
                            />
                          </div>
                        );
                      })
                    );
                  })}
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target={`#${getUniqueId()}`}
                  data-bs-slide="prev"
                >
                  <span
                    className="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target={`#${getUniqueId()}`}
                  data-bs-slide="next"
                >
                  <span
                    className="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </>
          )}
        </div>
        <div className={`${styles.cardTitle} text-truncate p-4`}>
          <span key={title}>{title}</span>
        </div>
        {isInteract && (
          <div className={`${styles.cardContent} px-4`}>
            {/* Publicações quiz */}
            {action.actionType === 'quiz' && (
              <div className={`${styles.details}`}>
                <span className={styles.badge}>
                  Questões: {action.questions && action.questions.length}
                </span>
                <span className={styles.badge}>
                  {(action.quizDetails?.quizType !== 'performance' &&
                    action.quizChoice === 'true') ||
                  (action.quizDetails?.quizType === 'performance' &&
                    action.quizDetails?.amountOfRetries === 1)
                    ? 'Única'
                    : 'Múltipla'}
                </span>
                <span className={styles.badge}>
                  Até: {action && moment(action.endDate).format('DD/MM/YYYY')}
                </span>
              </div>
            )}

            {/* Publicações NPS */}
            {action.actionType === 'researchAward' && (
              <div className={`${styles.details}`}>
                <span className={styles.badge}>{`${action.actionTitle}`}</span>
              </div>
            )}

            {/* Publicações que não são quiz ou nps e estão com compartilhamento ativado para MD */}
            {action.actionType !== 'quiz' &&
              action.actionType !== 'researchAward' &&
              action.shareButtonsVisible &&
              action.conversionType !== 'autoindicate' &&
              client &&
              client.clientUrl === 'md' && (
                <Clipboard actionId={action.id} shareUrl={action.shareUrl} />
              )}

            {/* Publicações que não são quiz ou nps geral */}
            {action.actionType !== 'quiz' &&
              action.actionType !== 'researchAward' &&
              action.conversionType !== 'autoindicate' &&
              client &&
              client.clientUrl !== 'md' && (
                <Clipboard actionId={action.id} shareUrl={action.shareUrl} />
              )}

            {/* Publicações que não são quiz ou nps geral */}
            {action.actionType !== 'quiz' &&
              action.actionType !== 'researchAward' &&
              action.conversionType === 'autoindicate' &&
              client &&
              client.clientUrl !== 'md' && (
                <div className={`${styles.details}`}>
                  <span
                    className={styles.badge}
                  >{`${action.actionTitle}`}</span>
                </div>
              )}

            {/* Publicações que não são quiz ou nps geral */}
            {action.actionType !== 'quiz' &&
              action.actionType !== 'researchAward' &&
              action.conversionType === 'autoindicate' &&
              client &&
              client.clientUrl === 'md' && (
                <div className={`${styles.details}`}>
                  <span
                    className={styles.badge}
                  >{`${action.actionTitle}`}</span>
                </div>
              )}

            {/* Publicações que não são quiz ou nps e NÃO estão com compartilhamento ativado para MD */}
            {action.actionType !== 'quiz' &&
              action.actionType !== 'researchAward' &&
              !action.shareButtonsVisible &&
              client &&
              client.clientUrl === 'md' && (
                <div className={`${styles.details}`}>
                  <span
                    className={styles.badge}
                  >{`${action.actionTitle}`}</span>
                </div>
              )}
          </div>
        )}
        <div className={`${styles.cardAction} mt-4`}>
          <button
            className={
              action.actionType === 'quiz' ||
              action.actionType === 'researchAward' ||
              action.conversionType === 'autoindicate' ||
              (client &&
                client.clientUrl === 'md' &&
                !action.shareButtonsVisible)
                ? styles.cta
                : action.conversionType === 'autoindicate'
                  ? styles.cta
                  : ''
            }
            onClick={() => {
              if (!isInteract) {
                navigate(routes.REGISTER_DETAILS);
              } else {
                onHandleActionDetails(action);
              }
            }}
          >
            <i className="material-icons-outlined mx-2">add</i>
            {action.conversionType !== 'autoindicate' && (
              <span>{ctaText ? ctaText : 'Mais detalhes'}</span>
            )}
            {action.conversionType === 'autoindicate' && (
              <span>
                {client.clientUrl === 'primeclinic'
                  ? 'Marcar agora'
                  : ctaText
                    ? ctaText
                    : player && player.regional === 'sim'
                      ? 'Registrar Lead'
                      : 'Indicar agora'}
              </span>
            )}
          </button>

          {/* verificação para MD para mostrar ou não o compartilhamento */}
          {action.actionType !== 'quiz' &&
            action.actionType !== 'researchAward' &&
            action.shareButtonsVisible &&
            action.conversionType !== 'autoindicate' &&
            client &&
            client.clientUrl === 'md' && (
              <>
                <button
                  className={styles.cta}
                  onClick={() => {
                    if (!isInteract) {
                      navigate(routes.REGISTER_DETAILS);
                    } else {
                      handleShareReveal();
                    }
                  }}
                >
                  <i className="material-icons-outlined mx-2">share</i>
                  <span>Compartilhe</span>
                </button>
              </>
            )}

          {/* verificação para GERAL para mostrar o compartilhamento */}
          {action.actionType !== 'quiz' &&
            action.actionType !== 'researchAward' &&
            action.conversionType !== 'autoindicate' &&
            client &&
            client.clientUrl !== 'md' && (
              <>
                <button
                  className={styles.cta}
                  onClick={() => {
                    if (!isInteract) {
                      navigate(routes.REGISTER_DETAILS);
                    } else {
                      handleShareReveal();
                    }
                  }}
                >
                  <i className="material-icons-outlined mx-2">share</i>
                  <span>Compartilhe</span>
                </button>
              </>
            )}
        </div>
        <div className={styles.revealWrapper}>
          <div
            className={`${styles.reveal} ${isOpenReveal ? styles.open : ''}`}
          >
            <div className={`${styles.content} p-4`}>
              <div className={styles.topReveal}>
                <span>Compartilhe</span>
                <button onClick={handleShareReveal}>
                  <i className="material-icons-outlined">close</i>
                </button>
              </div>
              <div className="container">
                <span className="">Compartilhe rapidamente via</span>
                <div className="my-3">
                  <ShareButton
                    action={action}
                    posterDownload
                    actionImagesBase64={actionImagesBase64}
                    cartazCover={cartazCover}
                  />
                </div>
                <span>Ou copie o link</span>
                <div className="mt-3">
                  <Clipboard shareUrl={action.shareUrl} actionId={action.id} />
                </div>
                {action && action.isAutoIndicateEnabled === 'true' && (
                  <>
                    <div className="mt-3">
                      <Link
                        to={`${routes.ACTION_DETAILS}/${action && action.id}?auto=true`}
                      >
                        <div className="d-grid">
                          <Button
                            text={
                              player && player.regional === 'sim'
                                ? ' Registrar Lead'
                                : 'Indicar Agora'
                            }
                            color="primary"
                            icon="new_releases"
                          />
                        </div>
                      </Link>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { CardReveal };
